<section class="left-nav-wrapper scroll-container">
  <h1 class="page-title mb-4">Run <span *ngIf="PayType == 3">Off-Cycle </span>Payroll</h1>
  <!-- schedule select screen -->
  <section *ngIf="schedules && !selSchedules.length && !activePayroll">
    <div class="row">
      <div class="col-12 text-center">
        <h4><strong>Choose a Payroll to Begin</strong></h4>
      </div>
      <div class="offset-md-5 mt-5 col-4">
        <div class="schedule-selection select-all" *ngIf="enableMultipleSchedules">
          <lib-checkbox
            label="Select All"
            [(ngModel)]="schedulePicker['selectAll']"
            (ngModelChange)="onScheduleChange('selectAll')"></lib-checkbox>
        </div>
        <div class="schedule-selection" *ngFor="let schedule of schedules">
          <lib-checkbox
            id="schedule-select-{{ schedule.CalendarId }}"
            [(ngModel)]="schedulePicker[schedule.CalendarId]"
            (ngModelChange)="onScheduleChange(schedule.CalendarId)"
            label="{{ schedule.ScheduleName }} (Scheduled Pay Date {{
              formatDate(schedule.ScheduledPayDate)
            }})"></lib-checkbox>
        </div>
      </div>
      <div class="col-12 text-center mt-4">
        <button class="btn btn-primary" [disabled]="!hasSchedulePicks" (click)="selectSchedules()">
          Confirm & Continue
        </button>
      </div>
    </div>
  </section>

  <!-- set pay date & period ends, 'before you begin' info/warnings/errors -->
  <div *ngIf="selSchedules.length" class="d-lg-flex d-md-block" [formGroup]="startPayrollForm">
    <div class="row align-self-center mx-8 my-10 w-100">
      <div class="col-12 col-lg-7 col-xl-5">
        <lib-payroll-start-schedule
          [activePayroll]="activePayroll"
          [startData]="startData"
          [isCsr]="isCsr"
          [location]="location"
          [payrollConfig]="payrollConfig"
          [locked]="locked"
          [lockedByProcessDueDate]="lockedByProcessDueDate"
          [minimumAvailableDate]="minimumAvailableDate"
          [payrollConfigSetupData]="payrollConfigSetupData"
          [payrollStartConfig]="payrollStartConfig"
          [selectedSchedules]="selSchedules"
          (payDateChanged)="onPayDateChanged($event)"
          [payType]="PayType"></lib-payroll-start-schedule>
        <div class="row">
          <div class="col-12 col-lg-4">
            <ng-container
              *ngIf="location && !activePayroll && payrollConfigSetupData?.Earnings?.length">
              <!-- ng if after earnings/deductions/taxes are fetched -->
              <lib-payroll-config
                [payDate]="payDate"
                [ptoConfigs]="ptoConfigs"
                [timeclockFile]="timeclockFile"
                [manualChecks]="manualChecks"
                [locationConfig]="location"
                [configSetupData]="payrollConfigSetupData"
                [payrollConfig]="payrollConfig"
                [stateLocalTaxes]="stateLocalTaxes"
                [locked]="locked"
                (saveChanges)="savePayrollConfig($event)">
              </lib-payroll-config>
            </ng-container>
          </div>
          <div
            class="col-12 col-lg-8 d-flex align-items-center justify-content-end"
            (mouseover)="markTouched()">
            <button class="btn btn-secondary" routerLink="/client/{{ clientCode }}/payroll-landing">
              Cancel
            </button>
            <button
              [disabled]="locked || !scheduleIsValid || lockedByProcessDueDate"
              cpGTagEvent
              [params]="{ event_label: 'reg_payroll_start' }"
              class="btn btn-primary ms-4 text-nowrap"
              (click)="startPayroll()">
              {{ activePayroll ? 'Resume Payroll' : 'Confirm & Continue' }}
            </button>
          </div>
        </div>
        <div class="mt-2">
          &nbsp;
          <em *ngIf="payrollConfig.hasOverrides() || activePayroll?.Config?.hasOverrides()">
            <small>*Temporary holds/overrides saved for this payroll</small>
          </em>
        </div>
      </div>
      <div class="col-12 col-lg-5 col-xl-6">
        <div *ngIf="activePayroll" class="mb-4">
          <h5 class="cp-green mb-0">Payroll entry in progress</h5>
          <small class="cp-green">
            Last edit by {{ activePayroll.LastEditBy }} on
            {{ activePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
          </small>
        </div>
        <before-you-begin
          *ngIf="payrollStartConfig"
          [errors]="payrollStartConfig.Errors"
          [warnings]="payrollStartConfig.Warnings"
          [unsupported]="payrollStartConfig.Unsupported">
        </before-you-begin>
        <lib-client-note-start *ngIf="isCsr" [clientCode]="clientCode"></lib-client-note-start>
      </div>
    </div>
  </div>
</section>
